import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { FeatureFlagService } from '../services/feature-flag.service';

@Injectable({
  providedIn: 'root'
})
export class OtdFlagGuard implements CanActivate {
  constructor(
    private router: Router,
    private featureFlagService: FeatureFlagService
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.featureFlagService.flagsResolved$.pipe(
      filter((flagsResolved) => flagsResolved),
      take(1),
      map(() => (this.featureFlagService.isOtdFundInvoiceSaleEnabled() ? true : this.router.parseUrl('/')))
    );
  }
}
